export default "__VITE_ASSET__D4fQ4hIk__"